import NotificationRecipientForm from 'pages/shared/NotificationRecipientForm'

import Api from 'services/api'

const AddNotificationRecipient = () => (
  <NotificationRecipientForm
    title="Add Notification Recipient"
    onValidatedSave={Api.NotificationRecipients.create}
    readOnlyMessage="Read-only view: can't add notification recipient"
  />
)

export default AddNotificationRecipient
